import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Cancel14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_47)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 0.25C3.27208 0.25 0.25 3.27208 0.25 7C0.25 10.7279 3.27208 13.75 7 13.75C10.7279 13.75 13.75 10.7279 13.75 7C13.75 3.27208 10.7279 0.25 7 0.25ZM1.75 7C1.75 4.1005 4.1005 1.75 7 1.75C8.17924 1.75 9.26767 2.13879 10.1441 2.79519L2.79519 10.1441C2.13879 9.26767 1.75 8.17924 1.75 7ZM3.85584 11.2048C4.73228 11.8612 5.82074 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 5.82073 11.8612 4.73228 11.2048 3.85584L3.85584 11.2048Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_47'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Cancel14.displayName = 'Cancel14';
export default Cancel14;
